import { useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";

import { EmptyStateMessage } from "../../../../shared/empty-state-message/empty-state-message.tsx";
import {
  Button,
  Checkbox,
  Select,
} from "../../../../ui/index.ts";
import { showError, showSuccess } from "../../../../../utils/toast.ts";
import { DISABLED_ROLE_NAME } from "../../constants.ts";
import { useEmployeeRoles } from "../../hooks/use-employee-roles.ts";
import { useEmployeesLookup } from "../../hooks/use-employees-lookup.ts";
import styles from "./roles-tab.module.css";

export function RolesTab() {
  const { employees, loading: employeesLoading, error: employeesError } =
    useEmployeesLookup();
  const {
    roles,
    checkedItems,
    selectedEmployeeId,
    loading,
    submitting,
    error,
    selectEmployee,
    toggleRole,
    saveRoles,
  } = useEmployeeRoles();

  useEffect(() => {
    if (employeesError) showError(employeesError);
  }, [employeesError]);

  useEffect(() => {
    if (error) showError(error);
  }, [error]);

  const handleSave = async () => {
    const result = await saveRoles();
    if (result.ok) {
      if (result.message) showSuccess(result.message);
    } else if (result.message) {
      showError(result.message);
    }
  };

  return (
    <div>

      <div className={styles.employeeSelect}>
        <Select
          id="roles-employee"
          label="Employee Name"
        placeholder={employeesLoading ? "Loading..." : "Select Employee Name"}

          searchable={true}
          options={employees}
          value={selectedEmployeeId ?? ""}
          onChange={(value) => selectEmployee(value || null)}
          disabled={employeesLoading || employees.length === 0}
        />
      </div>

      {!selectedEmployeeId ? (
        <EmptyStateMessage message="Select an employee to manage roles." />
      ) : loading ? (
        <div className={styles.loadingWrap}>
          <ThreeDots
            height="60"
            width="60"
            color="var(--color-accent-500)"
            visible
          />
        </div>
      ) : roles.length === 0 ? (
        <EmptyStateMessage message="No roles available for this employee." />
      ) : (
        <>
          <div className={styles.roleList}>
            {roles.map((role) => {
              const isDisabled =
                role.name.trim().toUpperCase() === DISABLED_ROLE_NAME;
              const checkboxId = `role-${role.roleId}`;
              return (
                <div key={role.roleId} className={styles.roleRow}>
                  <Checkbox
                    id={checkboxId}
                    label={role.name}
                    checked={Boolean(checkedItems[role.roleId])}
                    disabled={isDisabled}
                    onChange={(checked) => toggleRole(role.roleId, checked)}
                  />
                </div>
              );
            })}
          </div>

          <div className={styles.actions}>
            <Button
              variant="accent"
              onClick={() => void handleSave()}
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
